import PropTypes from 'prop-types';
import React from 'react';
import SpecCategory from './SpecCategory';

import '../global-sass/main.scss';

export default class DetailedSpecs extends React.Component {
	render() {
		const { prefs, specCategories, specification, widgetInfo } = this.props;

		if (specCategories.length === 0 || specification.length === 0) {
			return null;
		}

		return [
			specCategories.map(specCategory => {
				const { category = '', specIds = [] } = specCategory;
				if (category && specIds.length > 0) {
					return (
						<SpecCategory
							key={category}
							prefs={prefs}
							specCategory={category}
							specification={specification}
							specIds={specIds}
							widgetInfo={widgetInfo}
						/>
					);
				}
				return null;
			})
		];
	}
}

DetailedSpecs.propTypes = {
	prefs: PropTypes.objectOf(PropTypes.string),
	specCategories: PropTypes.arrayOf(
		PropTypes.shape({
			category: PropTypes.string,
			specIds: PropTypes.shape([])
		})
	),
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.shape({}).isRequired
		})
	),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

DetailedSpecs.defaultProps = {
	prefs: {},
	specCategories: [],
	specification: []
};
